// Area de envio de banner: clique ou arrastar-e-soltar.
//
// Os numeros da area segura foram MEDIDOS no navegador (25/08/2026), nao
// estimados. Convertidos pro arquivo de 1800x514:
//   celular 390px  -> banner exibido 390x111; o cartao cobre os 48px de baixo
//                     (= 222px no arquivo) e a logo redonda cobre 87px numa
//                     faixa central de 80px (= 403px de altura, x 715..1085);
//   desktop 1440px -> banner exibido 1088x311; cartao+logo cobrem 64px
//                     (= 106px no arquivo).
// O celular manda na regra por ser o corte mais agressivo dos dois.
// O recorte 3:1 acontece no backend, entao a orientacao de tamanho aqui e'
// so pra evitar que o lojista suba uma foto vertical e leve um corte agressivo.
//
// `aceitaVideo` (so a aba Cardapio, 23/10/2026): aceita tambem 1 video de ate
// 15 s, na mesma medida da imagem — o servidor recorta igual e tira o som.

import { ImagePlus, Loader2 } from "lucide-react";
import { useRef, useState } from "react";

export default function BannerUploader({ onArquivo, enviando, desabilitado, aceitaVideo = false }) {
  const inputRef = useRef(null);
  const [arrastando, setArrastando] = useState(false);
  const bloqueado = enviando || desabilitado;

  const escolher = (file) => {
    if (!file || bloqueado) return;
    onArquivo(file);
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); if (!bloqueado) setArrastando(true); }}
      onDragLeave={() => setArrastando(false)}
      onDrop={(e) => {
        e.preventDefault();
        setArrastando(false);
        escolher(e.dataTransfer?.files?.[0]);
      }}
      className={`rounded-2xl border-2 border-dashed transition-colors ${
        arrastando ? "border-primary bg-primary/5" : "border-border"
      } ${bloqueado ? "opacity-60" : ""}`}
    >
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={bloqueado}
        className="w-full flex flex-col items-center text-center px-6 py-10 disabled:cursor-not-allowed"
      >
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-3">
          {enviando ? (
            <Loader2 className="w-6 h-6 text-primary animate-spin" />
          ) : (
            <ImagePlus className="w-6 h-6 text-primary" strokeWidth={1.5} />
          )}
        </div>
        <span className="text-sm font-semibold">
          {enviando ? "Enviando…" : aceitaVideo ? "Adicionar banner (imagem ou vídeo)" : "Adicionar banner"}
        </span>
        <span className="text-xs text-muted-foreground mt-1 max-w-md">
          {desabilitado
            ? "Limite de banners atingido. Remova um antes de adicionar outro."
            : aceitaVideo
              ? "Clique ou arraste a imagem ou o vídeo aqui. Fora da proporção, é recortado no centro."
              : "Clique ou arraste a imagem aqui. Tamanho ideal 1800 × 514 px (3,5:1) — imagem fora dessa proporção é recortada no centro."}
        </span>
      </button>

      {aceitaVideo && !desabilitado && (
        <div className="grid sm:grid-cols-2 gap-2 px-6 pb-4 -mt-4 max-w-xl mx-auto text-[11px]">
          <div className="rounded-lg bg-muted/60 px-3 py-2">
            <p className="font-semibold text-foreground">Imagem</p>
            <p className="text-muted-foreground">1800 × 514 px (3,5:1) · JPG, PNG ou WebP</p>
          </div>
          <div className="rounded-lg bg-muted/60 px-3 py-2">
            <p className="font-semibold text-foreground">Vídeo · 1 por vez</p>
            <p className="text-muted-foreground">1800 × 514 px (3,5:1, deitado) · até 15 s · MP4 ou MOV · até 45 MB · toca sem som</p>
          </div>
        </div>
      )}

      {!desabilitado && (
        <p className="text-[11px] text-muted-foreground/80 text-center px-6 pb-5 -mt-2 max-w-md mx-auto">
          Deixe o <strong className="font-semibold">terço de baixo</strong> livre de
          textos e logos: no celular o cartão da loja cobre os 222 px inferiores, e a
          logo redonda cobre até 400 px no centro.
        </p>
      )}

      <input
        ref={inputRef}
        type="file"
        accept={aceitaVideo ? "image/*,video/mp4,video/quicktime,video/webm" : "image/*"}
        className="hidden"
        onChange={(e) => {
          escolher(e.target.files?.[0]);
          e.target.value = ""; // permite reenviar o mesmo arquivo
        }}
      />
    </div>
  );
}
